<template>
  <div class="bg-gray-100">
    <!-- Header -->
    <div class="relative flex justify-center items-center">
      <div class="absolute z-30 text-white px-6">
        <h1 class="text-4xl md:text-5xl leading-[50px] md:leading-[60px] font-serif text-center">{{
          $t('donations.support-us') }}</h1>
      </div>
      <div class="absolute z-20 inset-0 bg-black opacity-40"></div>
      <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw"
        class="object-cover min-h-[400px] w-full md:aspect-[3]" src="/images/donations.jpg"
        alt="Donazioni Hero Image" />
    </div>

    <div class="container mx-auto px-6 py-12 md:p-20">
      <p class="text-base text-gray-600 mb-10 md:mb-16">
        {{ $t('donations.support-message') }}
      </p>

      <div class="mt-8 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
        <div class="relative h-full">
          <div class="z-20 relative bg-white p-6 rounded-lg shadow-md h-full">
            <h2 class="text-xl md:text-2xl font-serif mb-4">{{ $t('donations.bank-transfer-title') }}</h2>
            <p class="text-base mb-2">{{ $t('donations.iban-label') }} <strong>IT76 G076 0104 8000 0104 0074
                625</strong></p>
            <p class="text-base mb-2">{{ $t('donations.account-name-label') }} <strong>Associazione Tau</strong></p>
            <p class="text-sm text-gray-600">{{ $t('donations.bank-transfer-note') }}</p>
          </div>
        </div>
        <div class="relative h-full">
          <div class="z-20 relative bg-white p-6 rounded-lg shadow-md h-full">
            <h2 class="text-xl md:text-2xl font-serif mb-4">{{ $t('donations.paypal-title') }}</h2>
            <p class="text-base mb-2">{{ $t('donations.paypal-message') }}</p>
            <form action="https://www.paypal.com/donate" method="post" target="_top">
              <input type="hidden" name="hosted_button_id" value="RGPA8L39SETTL" />
              <input type="image" src="https://www.paypalobjects.com/it_IT/IT/i/btn/btn_donate_LG.gif" border="0"
                name="submit" title="PayPal - The safer, easier way to pay online!"
                alt="Fai una donazione con il pulsante PayPal" />
              <img alt="" border="0" src="https://www.paypal.com/it_IT/i/scr/pixel.gif" width="1" height="1" />
            </form>

          </div>
        </div>
      </div>

      <div class="w-full self-end relative mt-10 md:mt-16">
        <div class="z-20 relative bg-white p-6 rounded-lg shadow-md">
          <h2 class="text-xl md:text-2xl font-serif mb-4">{{ $t('donations.5x1000-title') }}</h2>
          <p class="text-base mb-2">{{ $t('donations.5x1000-message') }}</p>
          <p class="text-base font-bold">{{ $t('donations.5x1000-fiscal-code') }} 92236610926</p>
          <p class="text-sm text-gray-600">{{ $t('donations.5x1000-note') }}</p>
          <p class="text-sm text-gray-600">{{ $t('donations.5x1000-instructions') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
